import { camelizeKeys } from 'humps';
import values from 'lodash/values';
import isuuid from 'isuuid';

// =====================
// =====================
// DEFAULT FUNCTIONALITY
// =====================
// =====================

// we key some user response values by
// their uuids, so we don't want to strip
// their '-'s
var maintainUUIDs = function maintainUUIDs(key, convert) {
  return isuuid(key) ? key : convert(key);
};

// convert snake_case to camelCase
export var camelizeNonUuidKeys = function camelizeNonUuidKeys(listOfObjects) {
  return camelizeKeys(listOfObjects, maintainUUIDs);
};
var camelizedVals = function camelizedVals(objectMap) {
  return camelizeNonUuidKeys(values(objectMap));
};
export default camelizedVals;